import {
  StudentProgress,
  StudentProgressStatus,
  Move,
  Syllabus,
  Clazz,
  User,
} from "../types";
import ResourceService from "../common/Services/ResourceService";

class SyllabusService extends ResourceService<Syllabus> {
  constructor() {
    super({
      path: "/syllabi",
      queryKey: "syllabi",
    });
  }

  static listSyllabi() {
    return new SyllabusService().list();
  }

  static fetchSyllabus(id: Syllabus["id"]) {
    return new SyllabusService().fetch({ id });
  }

  static createSyllabus(
    payload: Partial<Syllabus> & { moves?: Move["id"][]; clazz?: Clazz["id"] }
  ) {
    return new SyllabusService().create(payload);
  }

  static updateSyllabus(
    id: Syllabus["id"],
    payload: Partial<Syllabus> & { moves?: Move["id"][] }
  ) {
    return new SyllabusService().update({ ...payload, id });
  }

  static deleteSyllabus(id: Syllabus["id"]) {
    return new SyllabusService().deleteOne({ id });
  }

  static fetchSyllabusStudentProgress(
    id: Syllabus["id"],
    moveId: Move["id"],
    userId?: User["id"]
  ) {
    return new SyllabusService().fetchStudentProgress({ id, moveId, userId });
  }

  static updateSyllabusStudentProgress(
    id: Syllabus["id"],
    moveId: Move["id"],
    status: StudentProgressStatus
  ) {
    return new SyllabusService().updateStudentProgress({ id, moveId, status });
  }

  static listSyllabusMoves(id: Syllabus["id"]) {
    return new SyllabusService().listMoves({ id });
  }

  fetchStudentProgress({
    id,
    userId,
    moveId,
  }: {
    id: Syllabus["id"];
    moveId: Move["id"];
    userId?: User["id"];
  }): Promise<StudentProgress> {
    return this.get(
      [id, "student-progressions", moveId],
      userId
        ? {
            userId,
          }
        : undefined
    );
  }

  updateStudentProgress({
    id,
    moveId,
    status,
  }: {
    id: Syllabus["id"];
    moveId: Move["id"];
    status: StudentProgressStatus;
  }): Promise<StudentProgress> {
    return this.post([id, "student-progressions", moveId], {
      status,
    });
  }

  listMoves({ id }: Pick<Syllabus, "id">): Promise<Move[]> {
    return this.get([id, "moves"]);
  }
}

export default SyllabusService;
